var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWidgetCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00025 13.4578C10.5668 13.4578 13.458 10.5665 13.458 7.00001C13.458 3.43348 10.5668 0.542236 7.00025 0.542236C3.43372 0.542236 0.54248 3.43348 0.54248 7.00001C0.54248 10.5665 3.43372 13.4578 7.00025 13.4578Z",
    fill: "#1EAE98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C3.14051 14 0 10.86 0 7C0 3.14051 3.14051 0 7 0C10.86 0 14 3.14051 14 7C14 10.86 10.86 14 7 14ZM7 1.08443C3.73803 1.08443 1.08443 3.73803 1.08443 7C1.08443 10.262 3.73803 12.9156 7 12.9156C10.262 12.9156 12.9156 10.2614 12.9156 7C12.9156 3.73803 10.262 1.08443 7 1.08443Z",
    fill: "#1EAE98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15428 9.57555C6.00897 9.57555 5.87015 9.51753 5.76766 9.41343L3.7669 7.38013C3.55706 7.16649 3.55977 6.82382 3.7734 6.61344C3.98704 6.40415 4.33026 6.40631 4.54009 6.61994L6.13856 8.24441L9.44554 4.60236C9.64777 4.3806 9.99047 4.36488 10.2111 4.5655C10.4329 4.76667 10.4492 5.10934 10.248 5.33165L6.55552 9.39823C6.45522 9.50883 6.31424 9.57282 6.16513 9.57607C6.16133 9.57555 6.15808 9.57555 6.15428 9.57555Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetCheck);
export default __webpack_public_path__ + "static/media/widget-check.ec512bf68b1c5635c111fa322c1386ec.svg";
export { ForwardRef as ReactComponent };